import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Wo man sich in den Dateien befindet — als Teil der Adresse, damit Sidebar und Inhalt
 * dieselbe Auswahl sehen und ein Link auf einen Ordner funktioniert.
 */
export type FilesTab = "mine" | "shared";

export interface FilesLocation {
  tab: FilesTab;
  folderId: string | null;
  fileId: string | null;
  openFolder: (folderId: string | null) => void;
  openTab: (tab: FilesTab) => void;
}

export function useFilesLocation(): FilesLocation {
  const [params, setParams] = useSearchParams();

  const tab: FilesTab = params.get("tab") === "shared" ? "shared" : "mine";
  const folderId = params.get("folder");
  const fileId = params.get("file");

  const openFolder = useCallback(
    (next: string | null) => {
      setParams((current) => {
        const updated = new URLSearchParams(current);
        updated.set("tab", "mine");
        if (next) {
          updated.set("folder", next);
        } else {
          updated.delete("folder");
        }
        updated.delete("file");
        updated.delete("panel");
        return updated;
      });
    },
    [setParams],
  );

  const openTab = useCallback(
    (next: FilesTab) => {
      setParams((current) => {
        const updated = new URLSearchParams(current);
        updated.set("tab", next);
        // Der Ordner gehört zum eigenen Bereich und gilt in der Freigabe-Ansicht nicht.
        updated.delete("folder");
        updated.delete("file");
        updated.delete("panel");
        return updated;
      });
    },
    [setParams],
  );

  return useMemo(
    () => ({ tab, folderId, fileId, openFolder, openTab }),
    [tab, folderId, fileId, openFolder, openTab],
  );
}
